/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Note_RoomInputs */

const en_hub_note_room = /** @type {(inputs: Hub_Note_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your workshop can stay in Miro. Paste the board — sticky notes, frames, Excalidraw text, a Markdown note — and Bystep sorts it into the six steps of a Design Room, where the decisions turn into a PRD, features and tasks that a coding agent can verify. The whiteboard keeps the thinking; Bystep keeps the proof.`)
};

const id_hub_note_room = /** @type {(inputs: Hub_Note_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workshop-mu boleh tetap di Miro. Tempel papannya — sticky, frame, teks Excalidraw, catatan Markdown — dan Bystep menyortirnya ke enam langkah Design Room, tempat keputusan berubah jadi PRD, fitur dan task yang bisa diverifikasi agen. Papan tulis menyimpan pemikirannya; Bystep menyimpan buktinya.`)
};

/**
* | output |
* | --- |
* | "Your workshop can stay in Miro. Paste the board — sticky notes, frames, Excalidraw text, a Markdown note — and Bystep sorts it into the six steps of a Design..." |
*
* @param {Hub_Note_RoomInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_note_room = /** @type {((inputs?: Hub_Note_RoomInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Note_RoomInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_note_room(inputs)
	return en_hub_note_room(inputs)
});